import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SchoolServiceAdmin from '../services/SchoolServiceAdmin';
import { levelColors, levelTranslations } from './ConstFuncs';
import AdminDisplayTeacherAttendanceCheck from './AfterLoginPages/AdminDisplayTeacherAttendanceCheck';
import StatisticsAttendanceData from './AfterLoginPages/StatisticsAttendanceData';
import AttendanceTable from './AfterLoginPages/AttendanceTable';

const UpdateStudentGroup = ({ data, setData }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [allStudents, setAllStudents] = useState(null);
  const [allTeachers, setAllTeachers] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [showTransferModal, setShowTransferModal] = useState(false);
  let { teacherId } = useParams();
  const [myStudentsOnDateRange, setMyStudentsOnDateRange] =
    useState(null);

  useEffect(() => {
    if (!data) {
      localStorage.clear();
      navigate('/');
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (!allStudents) return; // wait until students are loaded
    if (allStudents.length === 0) return; // no students → skip auto-fetch

    // Calculate last 3 weeks (21 days)
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 21);

    const format = (d) => d.toISOString().split('T')[0];

    const autoStart = format(start);
    const autoEnd = format(end);

    setStartDate(autoStart);
    setEndDate(autoEnd);

    const fetchLastThreeWeeks = async () => {
      try {
        const response =
          await SchoolServiceAdmin.getMyStudentsOnDateRange(
            autoStart,
            autoEnd,
            teacherId,
          );

        const isAllEmpty = response.data.every(
          (arr) => !arr || arr.length === 0,
        );

        setMyStudentsOnDateRange(isAllEmpty ? null : response.data);
      } catch (err) {
        console.error('Auto-fetch last 3 weeks failed:', err);
      }
    };

    fetchLastThreeWeeks();
  }, [allStudents]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [studentsResponse, teachersResponse] = await Promise.all([
        SchoolServiceAdmin.getAllStudentsForTeacher(teacherId),
        SchoolServiceAdmin.getAllTeachers(),
      ]);
      setAllStudents(studentsResponse.data);
      setAllTeachers(
        teachersResponse.data.filter(
          (teacher) => teacher.id !== parseInt(teacherId),
        ),
      );
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const startDateRef = useRef();
  const endDateRef = useRef();

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name === 'start') {
      setStartDate(value);
    } else if (name === 'end') {
      setEndDate(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const startDate = startDateRef.current.value;
    const endDate = endDateRef.current.value;

    // Validate if dates are provided
    if (!startDate || !endDate) {
      alert('Please select both start and end dates.');
      return; // Stop further execution
    }

    try {
      const response =
        await SchoolServiceAdmin.getMyStudentsOnDateRange(
          startDate,
          endDate,
          teacherId,
        );
      const isAllEmpty = response.data.every(
        (arr) => !arr || arr.length === 0,
      );

      setMyStudentsOnDateRange(isAllEmpty ? null : response.data);

      console.log('RES: ', response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTransfer = async (newTeacherId) => {
    try {
      await SchoolServiceAdmin.transferStudent(
        selectedStudentId,
        newTeacherId,
      );
      setShowTransferModal(false);
      setSelectedStudentId(null);
      fetchData();
    } catch (error) {
      console.log('Error transferring student:', error);
    }
  };

  const clearAbsenceList = (event) => {
    event.preventDefault();

    setStartDate('');
    setEndDate('');
    setMyStudentsOnDateRange(null);
  };

  return (
    <div className="container mx-auto my-8">
      {!loading && (
        <div className="lg:flex-wrap lg:flex md:flex-1 my-4">
          <table className="min-w-full border rounded overflow-hidden">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="py-2 px-4">ID</th>
                <th className="py-2 px-4">First Name</th>
                <th className="py-2 px-4">Last Name</th>
                <th className="py-2 px-4">First Name Arabic</th>
                <th className="py-2 px-4">Last Name Arabic</th>
                <th className="py-2 px-4">Parents Email</th>
                <th className="py-2 px-4">Class Days Of Week</th>
                <th className="py-2 px-4">Student Level</th>
                <th className="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {allStudents?.map((myStudent) => (
                <tr
                  className="border-b text-center"
                  key={myStudent.id}
                >
                  <td className="py-2 px-4">{myStudent.id}</td>
                  <td className="py-2 px-4">{myStudent.firstName}</td>
                  <td className="py-2 px-4">{myStudent.lastName}</td>
                  <td className="py-2 px-4">
                    {myStudent.firstNameArabic}
                  </td>
                  <td className="py-2 px-4">
                    {myStudent.lastNameArabic}
                  </td>
                  <td className="py-2 px-4">{myStudent.email}</td>
                  <td className="py-2 px-4">
                    {myStudent.teacher.teacherClassDaysOfWeek.join(
                      ', ',
                    )}
                  </td>
                  <td
                    className={`py-2 font-semibold text-gray-300 ${
                      myStudent.level != null
                        ? levelColors[myStudent.level]
                        : 'bg-slate-600'
                    }`}
                  >
                    {myStudent.level != null
                      ? levelTranslations[myStudent.level]
                      : 'لم يتم الاختيار بعد'}
                  </td>
                  <td className="py-2 px-4 flex gap-2 justify-center">
                    <button
                      className="rounded bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 font-semibold"
                      onClick={() => {
                        setSelectedStudentId(myStudent.id);
                        setShowTransferModal(true);
                      }}
                    >
                      Transfer
                    </button>
                    <button
                      className="rounded bg-red-700 hover:bg-red-800 text-white px-6 py-2 font-semibold"
                      onClick={async () => {
                        const confirmDelete = window.confirm(
                          'Are you sure you want to delete this student?',
                        );

                        if (!confirmDelete) return;

                        const deleteType = window.prompt(
                          'Type "soft" for normal delete or "final" for full delete (including archive):',
                          'soft',
                        );

                        if (
                          deleteType !== 'soft' &&
                          deleteType !== 'final'
                        ) {
                          alert('Invalid choice. Delete cancelled.');
                          return;
                        }

                        try {
                          await SchoolServiceAdmin.deleteStudent(
                            teacherId,
                            myStudent.id,
                            deleteType === 'final' ? true : false,
                          );
                          fetchData();
                        } catch (error) {
                          console.error(
                            'Error deleting student:',
                            error,
                          );
                        }
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showTransferModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <h3 className="text-xl font-semibold mb-4">
              Select New Teacher
            </h3>
            <div className="overflow-y-auto max-h-64">
              {' '}
              {/* Scrollable container */}
              <ul className="space-y-2">
                {allTeachers?.map((teacher) => (
                  <li key={teacher.id}>
                    <button
                      className="w-full text-left px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded"
                      onClick={() => handleTransfer(teacher.id)}
                    >
                      {teacher.firstName} {teacher.lastName}
                      {' | '}
                      {teacher.classAbbrev}
                      {' | Class Unique Number: '}
                      {teacher.classUniqueNumber}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded"
              onClick={() => setShowTransferModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <hr className="w-960 h-2 mx-auto my-4 bg-cyan-800 border-0 rounded md:my-10 dark:bg-gray-700" />
      <h1 className="md:text-2xl text-2xl text-center font-semibold text-cyan-900 py-4">
        Get Absence List For DateRange For This Class:
      </h1>
      <div className="w-full flex justify-center">
        <form onSubmit={handleSubmit} className="text-center">
          <input
            ref={startDateRef}
            type="date"
            name="start"
            value={startDate}
            onChange={handleDateChange}
            className="w-60 block px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
          />
          <input
            ref={endDateRef}
            type="date"
            name="end"
            value={endDate}
            onChange={handleDateChange}
            className="w-60 block px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500 mt-2"
          />
          <div className="grid grid-cols-2 gap-x-2">
            <button
              type="submit"
              className="rounded bg-blue-600 text-white px-2 py-2 my-2 font-semibold hover:bg-blue-700"
            >
              Fetch
            </button>
            <button
              onClick={clearAbsenceList}
              className="rounded bg-gray-600 text-white px-2 py-2 my-2 font-semibold hover:bg-gray-700"
            >
              Clear and Hide
            </button>
          </div>
        </form>
      </div>

      {myStudentsOnDateRange && myStudentsOnDateRange.length > 0 ? (
        <>
          <div className="lg:flex-wrap lg:flex md:flex-1 my-4">
            <AttendanceTable data={myStudentsOnDateRange} />
          </div>
          <div className="flex justify-center items-center gap-4 text-lg font-semibold">
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-700">
                ✓
              </span>
              <span className="text-green-700">Present</span>
            </span>
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700">
                📚
              </span>
              <span className="text-blue-700">Homework</span>
            </span>
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-yellow-100 text-yellow-700">
                ⏰
              </span>
              <span className="text-yellow-700">Late</span>
            </span>
            <span className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-red-100 text-red-700">
                ⚠️
              </span>
              <span className="text-red-700">Disturb</span>
            </span>
          </div>
          <hr className="w-960 h-2 mx-auto my-4 bg-cyan-800 border-0 rounded md:my-10 dark:bg-gray-700" />

          <StatisticsAttendanceData data={myStudentsOnDateRange} />
        </>
      ) : (
        <div className="text-center my-10 text-gray-500 text-lg font-medium">
          No data available for the selected date range 📭
        </div>
      )}

      <hr className="w-960 h-2 mx-auto my-4 bg-cyan-800 border-0 rounded md:my-10 dark:bg-gray-700" />

      <div className="mx-auto text-center">
        <button
          onClick={() => {
            navigate('/schoolsuperadmin');
          }}
          className="rounded text-white px-6 py-2 font-semibold bg-cyan-700 hover:bg-cyan-800"
        >
          Back To Dashboard
        </button>
      </div>
    </div>
  );
};

export default UpdateStudentGroup;
